import PrefacturationDetailController from './prefacturation.detail.controller';

export default {
    template: require('./prefacturation.detail.html'),
    controller: PrefacturationDetailController
};
